import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Util from 'utility';
import { __ } from 'locale';
import { setFoodGroupDescription } from 'actions/index';

const inputRowCls = 'flex w-full flex-wrap items-start py-[4px] [&>img]:self-center [&>span]:w-[15em] [&>span]:basis-[15em] [&>span]:mt-[0.5em] [&>span.error]:text-[#f00] [&>span.error]:font-bold';
const inputsCls = 'flex-1 flex flex-wrap items-center [&>input]:w-full [&>input]:py-[0.35em] [&>input]:px-[0.5em] [&>input]:border [&>input]:border-[#ccc] [&>input]:rounded [&>input]:mr-[0.5em] [&>input]:shadow-[inset_1px_2px_4px_rgba(0,0,0,0.1)] [&>textarea]:w-full [&>textarea]:h-[8em] [&>textarea]:py-[0.35em] [&>textarea]:px-[0.5em] [&>textarea]:border [&>textarea]:border-[#ccc] [&>textarea]:rounded [&>select]:w-full [&>select]:py-[0.35em] [&>select]:px-[0.5em] [&>select]:border [&>select]:border-[#ccc] [&>select]:rounded [&>select]:mr-[0.5em]';

function PanelRecipeSettings() {
    const data = useSelector(state => state);
    const dispatch = useDispatch();
    const { globals } = data;
    const mealHash = data.activeMealHash;

    const firstGroupId = Object.keys(data.foodGroups[mealHash] || {})[0] || false;
    const [selectedFoodGroupId, setSelectedFoodGroupId] = useState(firstGroupId);

    const updateFoodGroupDescription = (e) => {
        dispatch(setFoodGroupDescription({ id: selectedFoodGroupId, description: e.target.value }));
        Util.saveCurrentRecipeLocal();
    };

    const foodGroupsOptions = Object.keys(data.foodGroups[mealHash] || {}).map(g => {
        const group = data.foodGroups[mealHash][g];
        const title = group.title || '- beze jména -';
        return <option value={g} key={g}>{globals.foodGroupTypes[group.type]}: {title}</option>;
    });

    const currentFoodGroupDescription = data.foodGroups[mealHash]?.[selectedFoodGroupId]?.description || '';

    return (
        <div className="flex flex-wrap">
            <div className="flex-1">
                <div className={inputRowCls}>
                    <span style={{flexBasis:'10em'}}>{__('Vyberte chod')}:</span>
                    <div className={inputsCls}>
                        <select onChange={e => setSelectedFoodGroupId(e.target.value)} defaultValue={selectedFoodGroupId}>{foodGroupsOptions}</select>
                    </div>
                </div>
                <div className={inputRowCls}>
                    <span style={{flexBasis:'10em'}}>{__('Postup přípravy')}:</span>
                    <div className={inputsCls}>
                        <textarea onChange={updateFoodGroupDescription} style={{ height: '9em' }} value={currentFoodGroupDescription}></textarea>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PanelRecipeSettings;
